import { useState } from 'react';
import { Button } from 'shared-components';
import { UploadZone } from '../uploader/upload-zone';
import { addUploads } from '../uploader/uploader-slice';
import { close } from '../modal/modalSlice';
import { ButtonTier } from 'shared-components';
import { useAppDispatch } from '../../app/hooks';
import { Upload } from '../uploader/uploader.types';
import { useGetArchiveUploadUrlMutation } from './archives.api';
import styles from './archive-upload-modal.module.css';

export const ArchiveUploadModal = () => {
  const dispatch = useAppDispatch();
  const [uploadList, setUploadList] = useState<
    Pick<Upload, 'file' | 'destination'>[]
  >([]);
  const [getUrl] = useGetArchiveUploadUrlMutation();
  return (
    <div className={styles.archiveUploadModal}>
      <UploadZone
        className={styles.uploadZone}
        allowMultiple={false}
        onFileChange={(files) => {
          const newList = files.map((file) => ({
            file,
            destination: ``,
          }));
          setUploadList(newList);
        }}
      />
      <Button
        bigger={true}
        tier={ButtonTier.Secondary}
        onClick={() => {
          dispatch(close());
        }}
      >
        Cancel
      </Button>
      {uploadList.length > 0 && (
        <Button
          bigger={true}
          onClick={async () => {
            //get upload url and update uploadList

            const urlResponse = (await getUrl(uploadList[0].file.name)) as {
              data: { url: string };
            };
            dispatch(
              addUploads([
                {
                  file: uploadList[0].file,
                  destination: urlResponse.data.url,
                  onComplete: [
                    {
                      action: 'invalidateTags',
                      args: ['Archives'],
                    },
                  ],
                },
              ])
            );

            dispatch(close());
          }}
        >
          Upload
        </Button>
      )}
    </div>
  );
};
